const env = {
  apiUrl: "https://proposals-api.furnishr.com/api/v1/",
  domain: "proposals-api.furnishr.com",
  domainFe: "https://proposals-api.furnishr.com",
  domainFeAdmin: "https://view.furnishr.com"
}

export default env
